<template>
	<div :class="`static-content-terms${cssClass}`">
		<div class="header">
			<h1>{{ $t('labels.general.use_policy') }}</h1>
		</div>
		<div class="body">
			<spinner v-if="collection.loading"/>
			<div v-html="current.content"></div>
		</div>
	</div>
</template>

<script>
import ApiCollection from '@/classes/api/ApiCollection'
export default {
	props: [
		'cssprop'
	],
	data () {
		return {
			collection: new ApiCollection()
		}
	},
	computed: {
		current () {
			return this.collection.data.find(ele => ele.lang == this.$i18n.locale) || {}
		},
		cssClass () {
			return this.cssprop ? `-${this.cssprop}` : ''
		}
	},
	methods: {
		getCollection () {
			this.collection.loading = true
			this.$api.statics.getStaticContent(this, 'use-policy')
				.then(response => {
					this.$log.info('admin', 'statics.getStaticContent OK', response)()
					this.collection.data = response.body.length ? response.body : []
				})
				.catch(error => {
					this.$log.error('admin', 'statics.getStaticContent ERROR', error)()
					this.collection.error = error
				})
				.finally(() => {
					this.collection.loading = false
				})
		}
	},
	mounted () {
		this.getCollection()
	}
}
</script>



// WEBPACK FOOTER //
// src/components/statics/StaticContentUsePolicy.vue